import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { DateService, DateTimeService, useTimezone } from '@mews/framework';

export const useAccountLedgersEffectiveDateSuspenseQuery = () =>
    useRepositorySuspenseQuery('accounting', 'getEffectiveDate', {});

export const useIsEffectiveDateBeforeCurrentDate = () => {
    const {
        data: { effectiveDate },
    } = useAccountLedgersEffectiveDateSuspenseQuery();
    const timezone = useTimezone();

    if (!effectiveDate) {
        return false;
    }

    const dateToday = DateService.today(timezone);
    const parsedEffectiveDateTime = DateTimeService.toDate(DateTimeService.parse(effectiveDate, timezone));

    return DateService.isLess(parsedEffectiveDateTime, dateToday);
};
